import { checkClass } from "../../tools/checkClass";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PanelFrame from "../../ui/PanelFrame";
import { useLang } from "../../../i18n/LangContext";
import "./top10players.scss";

const PLACEHOLDER_COUNT = 5;

const Top10Players = () => {
  const { t } = useLang();
  // Same payload order as /ranking (MasterResetCount DESC, Reset DESC, cLevel DESC).
  const top100Players = useSelector(
    (state) => state.reducerWeb.top100Players.data
  );
  const navigate = useNavigate();
  const rows = Array.isArray(top100Players) ? top100Players.slice(0, 5) : [];
  const hasData = rows.length > 0;

  return (
    <PanelFrame title={t("top_players")}>
      <div className="containerTop10Players">
        <table className="Top10Players mu-table">
          <thead>
            <tr>
              <th>#</th>
              <th>{t("col_player")}</th>
              <th>{t("col_level")}</th>
              <th>{t("col_reset")}</th>
              <th>{t("col_grand_reset")}</th>
            </tr>
          </thead>
          <tbody>
            {hasData
              ? rows.map((player, i) => (
                  <tr
                    className="newCursor"
                    onClick={() => navigate(`/player/${player.Name}`)}
                    key={player.Name || i}
                  >
                    <td>{i + 1}</td>
                    <td>
                      <span>
                        <img
                          className="playerClass"
                          src={checkClass(player.Class)}
                          alt=""
                        />
                        {player.Name}
                      </span>
                    </td>
                    <td>{player.cLevel}</td>
                    <td>{player.Reset}</td>
                    <td>{player.GrandReset ?? 0}</td>
                  </tr>
                ))
              : Array.from({ length: PLACEHOLDER_COUNT }).map((_, i) => (
                  <tr key={`empty-${i}`} className="mu-row-placeholder">
                    <td>{i + 1}</td>
                    <td>—</td>
                    <td>—</td>
                    <td>—</td>
                    <td>—</td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </PanelFrame>
  );
};

export default Top10Players;
